module.exports = __webpack_public_path__ + "img/main-2.a91a077e.svg";